export interface IAlternatives {
	customerData: ICustomerData;
	offerList: IOfferList[] | [];
	alternativeSelected: IAlternativeSelected;
	index: number;
	error: boolean;
	code: string;
	creditList?: Credit[];
}

export interface ICustomerData {
	expirationDate: string;
	alternativeType: string;
	state: string;
	customerName: string;
	mobilePhone: string;
	callDays: string;
	actionCode: number;
	opportunityId: string;
	obligaciones: string[];
	newMobilePhone: string;
}

export interface IOfferList {
	packageName: string;
	needCode: number;
	alternativeConditions: string;
	creditsNumber: number;
	feeDuringGracePeriod: string;
	newAmortizationDescription: string;
	details: IDetails;
}

export interface Credit {
  loanNumber: string;
  loanBalanceCapital: number | null;
  loanBalanceInteresCorriente: number | null;
  loanBalanceInteresesOrden: number | null;
  diasDeMora: number;
  cuotaActual: number | null;
  tasaDeIinteres: number;
}

export interface IAlternativeSelected {
	packageName: string;
	needCode: number;
	alternativeConditions: string;
	creditsNumber: number;
	feeDuringGracePeriod: string;
	newAmortizationDescription: string;
	details: IDetails;
}

export interface IDetails {
	newConditions: INewConditions;
	creditsIncluded: ICreditsIncluded[];
}

export interface INewConditions {
	term: string;
	gracePeriod: string;
	newFee: string;
	feeAfterGracePeriod: string;
	unifiedValueFNG: string;
	feeFNG: string;
	newCapital: string;
	rate: string;
	rateType?: string;
	newNominalRate?: string;
	plan?: string;
	concepto?: string;
	bajoMonto?: string;
	newAmortization?: string;
	newAmortizationDescription?: string;
	externalCustomerClassification?: string;
	newExternalCustomerClassification?: string;
	newRatePoint?: string;
	paymentOption?: string

}

export interface ICreditsIncluded {
	nameObligation: string;
	loanNumber: string;
	loanNumberComplete: string;
	loanBalance?: number;
	currentFee?: number;
	previousRateTypeDescriptionn?: string;
	previousAmortizationTypeDescription?: string;
	rateByLoan?: number;
	application?: string;
	currency?: string;
	concepto?: string;
	manejoDeCupos?: string;
	diasDeMora?: string;
	valorTrm?: string;
}

export const initialStateAlternatives: IAlternatives = {
	customerData: {
		expirationDate: "",
		alternativeType: "",
		state: "",
		customerName: "",
		mobilePhone: "",
		callDays: "",
		actionCode: 0,
		opportunityId: "",
		obligaciones: ["", ""],
		newMobilePhone: ""
	},
	offerList: [
		{
			packageName: "",
			creditsNumber: 0,
			needCode: 0,
			alternativeConditions: "",
			feeDuringGracePeriod: "",
			newAmortizationDescription: "",
			details: {
				newConditions: {
					term: "",
					gracePeriod: "",
					newFee: "",
					feeAfterGracePeriod: "",
					unifiedValueFNG: "",
					feeFNG: "",
					newCapital: "",
					rate: "",
					rateType: "",
					newNominalRate: "",
					plan: "",
					concepto: "",
					bajoMonto: "",
					newAmortization: "",
					newAmortizationDescription: "",
					externalCustomerClassification: "",
					newExternalCustomerClassification: "",
					newRatePoint: "",
					paymentOption: ""
				},
				creditsIncluded: [
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					}
				]
			}
		}
	],
	alternativeSelected: {
		packageName: "",
		creditsNumber: 0,
		needCode: 0,
		alternativeConditions: "",
		feeDuringGracePeriod: "",
		newAmortizationDescription: "",
		details: {
			newConditions: {
				term: "",
				gracePeriod: "",
				newFee: "",
				feeAfterGracePeriod: "",
				unifiedValueFNG: "",
				feeFNG: "",
				newCapital: "",
				rate: "",
				rateType: "",
				newNominalRate: "",
				plan: "",
				concepto: "",
				bajoMonto: "",
				newAmortization: "",
				newAmortizationDescription: "",
				externalCustomerClassification: "",
				newExternalCustomerClassification: "",
				newRatePoint: "",
				paymentOption: ""
			},
			creditsIncluded: [
				{
					nameObligation: "",
					loanNumber: "",
					loanNumberComplete: "",
					loanBalance: 0,
					currentFee: 0,
					previousRateTypeDescriptionn: "",
					previousAmortizationTypeDescription: "",
					rateByLoan: 0,
					application: "",
					currency: "",
					manejoDeCupos: "",
					diasDeMora: ""
				}
			]
		}
	},
	index: 0,
	error: false,
	code: "000"
};

export const LogAlternatives: IAlternatives = {
	customerData: {
		expirationDate: "",
		alternativeType: "Consolidacion",
		state: "",
		customerName: "RAMON",
		mobilePhone: "",
		callDays: "",
		actionCode: 0,
		opportunityId: "",
		obligaciones: ["", ""],
		newMobilePhone: ""
	},
	offerList: [
		{
			packageName: "",
			needCode: 0,
			alternativeConditions: "",
			creditsNumber: 0,
			feeDuringGracePeriod: "",
			newAmortizationDescription: "",
			details: {
				newConditions: {
					term: "",
					gracePeriod: "",
					newFee: "",
					feeAfterGracePeriod: "",
					unifiedValueFNG: "",
					feeFNG: "",
					newCapital: "",
					rate: "",
					rateType: "",
					newNominalRate: "",
					plan: "",
					concepto: "",
					bajoMonto: "",
					newAmortization: "",
					newAmortizationDescription: "",
					externalCustomerClassification: "",
					newExternalCustomerClassification: "",
					newRatePoint: "",
					paymentOption: ""
				},
				creditsIncluded: [
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					}
				]
			}
		},
		{
			packageName: "",
			needCode: 0,
			alternativeConditions: "",
			creditsNumber: 0,
			feeDuringGracePeriod: "",
			newAmortizationDescription: "",
			details: {
				newConditions: {
					term: "",
					gracePeriod: "",
					newFee: "",
					feeAfterGracePeriod: "",
					unifiedValueFNG: "",
					feeFNG: "",
					newCapital: "",
					rate: "",
					rateType: "",
					newNominalRate: "",
					plan: "",
					concepto: "",
					bajoMonto: "",
					newAmortization: "",
					newAmortizationDescription: "",
					externalCustomerClassification: "",
					newExternalCustomerClassification: "",
					newRatePoint: "",
					paymentOption: ""
				},
				creditsIncluded: [
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					}
				]
			}
		}
	],
	alternativeSelected: {
		packageName: "",
		creditsNumber: 0,
		needCode: 0,
		alternativeConditions: "",
		feeDuringGracePeriod: "",
		newAmortizationDescription: "",
		details: {
			newConditions: {
				term: "",
				gracePeriod: "",
				newFee: "",
				feeAfterGracePeriod: "",
				unifiedValueFNG: "",
				feeFNG: "",
				newCapital: "",
				rate: "",
				rateType: "",
				newNominalRate: "",
				plan: "",
				concepto: "",
				bajoMonto: "",
				newAmortization: "",
				newAmortizationDescription: "",
				externalCustomerClassification: "",
				newExternalCustomerClassification: "",
				newRatePoint: "",
				paymentOption: ""
			},
			creditsIncluded: [
				{
					nameObligation: "",
					loanNumber: "",
					loanNumberComplete: "",
					loanBalance: 0,
					currentFee: 0,
					previousRateTypeDescriptionn: "",
					previousAmortizationTypeDescription: "",
					rateByLoan: 0,
					application: "",
					currency: "",
					manejoDeCupos: "",
					diasDeMora: ""
				}
			]
		}
	},
	index: 0,
	error: false,
	code: "000"
};

export const offerSV: IAlternatives = {
	customerData: {
		expirationDate: "",
		alternativeType: "",
		state: "",
		customerName: "",
		mobilePhone: "",
		callDays: "",
		actionCode: 0,
		opportunityId: "",
		obligaciones: ["", ""],
		newMobilePhone: ""
	},
	offerList: [
		{
			packageName: "",
			needCode: 0,
			alternativeConditions: "",
			creditsNumber: 0,
			feeDuringGracePeriod: "",
			newAmortizationDescription: "",
			details: {
				newConditions: {
					term: "",
					gracePeriod: "",
					newFee: "",
					feeAfterGracePeriod: "",
					unifiedValueFNG: "",
					feeFNG: "",
					newCapital: "",
					rate: "",
					rateType: "",
					newNominalRate: "",
					plan: "",
					concepto: "",
					bajoMonto: "",
					newAmortization: "",
					newAmortizationDescription: "",
					externalCustomerClassification: "",
					newExternalCustomerClassification: "",
					newRatePoint: "",
					paymentOption: ""
				},
				creditsIncluded: [
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					},
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					}
				]
			}
		},
		{
			packageName: "",
			needCode: 0,
			alternativeConditions: "",
			creditsNumber: 0,
			feeDuringGracePeriod: "",
			newAmortizationDescription: "",
			details: {
				newConditions: {
					term: "",
					gracePeriod: "",
					newFee: "",
					feeAfterGracePeriod: "",
					unifiedValueFNG: "",
					feeFNG: "",
					newCapital: "",
					rate: "",
					rateType: "",
					newNominalRate: "",
					plan: "",
					concepto: "",
					bajoMonto: "",
					newAmortization: "",
					newAmortizationDescription: "",
					externalCustomerClassification: "",
					newExternalCustomerClassification: "",
					newRatePoint: "",
					paymentOption: ""
				},
				creditsIncluded: [
					{
						nameObligation: "",
						loanNumber: "",
						loanNumberComplete: "",
						loanBalance: 0,
						currentFee: 0,
						previousRateTypeDescriptionn: "",
						previousAmortizationTypeDescription: "",
						rateByLoan: 0,
						application: "",
						currency: "",
						manejoDeCupos: "",
						diasDeMora: ""
					}
				]
			}
		}
	],
	alternativeSelected: {
		packageName: "",
		creditsNumber: 0,
		needCode: 0,
		alternativeConditions: "",
		feeDuringGracePeriod: "",
		newAmortizationDescription: "",
		details: {
			newConditions: {
				term: "",
				gracePeriod: "",
				newFee: "",
				feeAfterGracePeriod: "",
				unifiedValueFNG: "",
				feeFNG: "",
				newCapital: "",
				rate: "",
				rateType: "",
				newNominalRate: "",
				plan: "",
				concepto: "",
				bajoMonto: "",
				newAmortization: "",
				newAmortizationDescription: "",
				externalCustomerClassification: "",
				newExternalCustomerClassification: "",
				newRatePoint: "",
				paymentOption: ""
			},
			creditsIncluded: [
				{
					nameObligation: "",
					loanNumber: "",
					loanNumberComplete: "",
					loanBalance: 0,
					currentFee: 0,
					previousRateTypeDescriptionn: "",
					previousAmortizationTypeDescription: "",
					rateByLoan: 0,
					application: "",
					currency: "",
					manejoDeCupos: "",
					diasDeMora: ""
				}
			]
		}
	},
	index: 0,
	error: false,
	code: "000"
};
